import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function ExternalEmbed(props: {
  record: FragmentOf<typeof fragment.externalEmbedFragment>;
}) {
  const record = readFragment(fragment.externalEmbedFragment, props.record);

  const videoId = record.externalVideo.providerUid;

  return (
    <div className="group container mx-auto my-10 grid h-full max-w-[780px] grid-cols-6 overflow-hidden px-4 lg:px-0">
      <div className="relative col-span-6 h-0 pb-[56.25%]">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}`}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute top-0 left-0 h-full w-full"
        ></iframe>
      </div>
    </div>
  );
}
